import React from 'react';
import { NavCategoryContext } from '../../enums/NavCategoryContext.enum';
import { useNavCategories } from '../../hooks/actions/useNavCategories';
import { CollectionCategory } from './CollectionCategory';
import { ScrollableContainer } from './ScrollableContainer';

interface Props {
  context: NavCategoryContext;
  style?: React.CSSProperties;
}

export const CollectionCategories: React.FC<Props> = ({ style, context }) => {
  const { navCategorySets, activeNavCategorySet } = useNavCategories({ context });
  const allowScroll = navCategorySets.length > 4;

  return (
    <ScrollableContainer allowScroll={allowScroll} style={style}>
      {navCategorySets.map((c) => (
        <CollectionCategory navCategorySet={c} isActive={activeNavCategorySet.navCategory === c.navCategory} key={c.navCategory} />
      ))}
    </ScrollableContainer>
  );
};

export default CollectionCategories;
